import { Button } from "components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import { IStoreDeposit } from "src/@types/store-deposit-maintenance";

import { formatAmount, formatOperationDate, text } from "../deposit-formatters";
import { DEPOSIT_MAINTENANCE_LABELS } from "../types";

interface BankDetailsModalProps {
  readonly deposit: IStoreDeposit | null;
  readonly bankName: string | undefined;
  readonly onClose: () => void;
}

export function BankDetailsModal(props: BankDetailsModalProps) {
  if (props.deposit === null) return null;

  const deposit: IStoreDeposit = props.deposit;

  return (
    <Dialog open onOpenChange={props.onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {DEPOSIT_MAINTENANCE_LABELS.bankDetailsTitle}
          </DialogTitle>
          <DialogDescription>
            {DEPOSIT_MAINTENANCE_LABELS.bankDetailsDescription}
          </DialogDescription>
        </DialogHeader>

        <dl className="grid grid-cols-2 gap-3 text-sm text-slate-700">
          <div>
            <dt className="text-xs text-slate-500">
              {DEPOSIT_MAINTENANCE_LABELS.depositDateLabel}
            </dt>
            <dd>{formatOperationDate(deposit.operationDate)}</dd>
          </div>
          <div>
            <dt className="text-xs text-slate-500">
              {DEPOSIT_MAINTENANCE_LABELS.depositAmountLabel}
            </dt>
            <dd>{formatAmount(deposit.amount)}</dd>
          </div>
          <div>
            <dt className="text-xs text-slate-500">
              {DEPOSIT_MAINTENANCE_LABELS.bankLabel}
            </dt>
            <dd>{text(props.bankName ?? deposit.bankNumber)}</dd>
          </div>
          <div>
            <dt className="text-xs text-slate-500">
              {DEPOSIT_MAINTENANCE_LABELS.nsuLabel}
            </dt>
            <dd className="font-mono">{text(deposit.nsu)}</dd>
          </div>
          <div>
            <dt className="text-xs text-slate-500">
              {DEPOSIT_MAINTENANCE_LABELS.agencyLabel}
            </dt>
            <dd>{text(deposit.agency)}</dd>
          </div>
          <div>
            <dt className="text-xs text-slate-500">
              {DEPOSIT_MAINTENANCE_LABELS.accountLabel}
            </dt>
            <dd>{text(deposit.account)}</dd>
          </div>
          <div className="col-span-2">
            <dt className="text-xs text-slate-500">
              {DEPOSIT_MAINTENANCE_LABELS.complementLabel}
            </dt>
            <dd className="font-mono">{text(deposit.complement)}</dd>
          </div>
        </dl>

        <DialogFooter>
          <Button variant="ghost" onClick={props.onClose}>
            {DEPOSIT_MAINTENANCE_LABELS.closeButton}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
